import {Controller} from "stimulus"

var delayTimer;
export default class extends Controller {
    static targets = ["licenseTypeSelect"]

    connect() {
        console.log("hello from reports-license_activity");
    }

    // Navigation seam. Assigning window.location.href is the side effect under
    // test, but jsdom (26+, pulled in by jest-environment-jsdom 30) makes
    // window.location non-configurable and does not implement navigation, so
    // specs can neither stub nor read it back. Routing the redirect through this
    // method lets tests spy on controller.navigateTo to assert the built URL
    // without touching the global. Keep this a thin pass-through.
    navigateTo(url) {
        window.location.href = url;
    }

    selectAllLicenseTypes(e) {
        e.preventDefault()
        this._clearLicenseTypeSelection()
    }

    selectNoLicenseTypes(e) {
        e.preventDefault()
        this._setAllLicenseTypeOptions(false)
    }

    updateReport(e) {
        console.log("report changed")
        clearTimeout(delayTimer);
        delayTimer = setTimeout(() => {
            const dateFrom = document.getElementById("date_from")
            const dateTo = document.getElementById("date_to")
            if (dateFrom.value != "" && dateTo.value != "" || dateFrom.value == "" && dateTo.value == "") {
                document.getElementById("flash-area").innerHTML = ""
                const reportLicenses = document.getElementById("report_type")
                const reportActivity = document.getElementById("activity_type")
                const jurisdiction = document.getElementById("jurisdiction_id")
                const classification = document.getElementById("classification")
                const residency = document.getElementById("residency")
                const homeBased = document.getElementById("home_based") || { value: "all" }
                const licenseTypeIds = Array.from(this.licenseTypeSelectTarget.selectedOptions).map(o => o.value).join(",")
                let title = "License Activity: " + reportActivity.value + " Licenses " + reportLicenses.value + ": "
                if (dateFrom.value != "") {
                    title += dateFrom.value + " to " + dateTo.value;
                } else {
                    title += "Month to Date";
                }
                let reportUrl = 'chart?title=' + title +
                    '&data_source=reports_licenses_activity_path&date_from=' + dateFrom.value +
                    '&date_to=' + dateTo.value + '&report_type=' + reportLicenses.value +
                    '&activity_type=' + reportActivity.value + '&classification=' + classification.value +
                    '&residency=' + residency.value +
                    '&home_based=' + homeBased.value
                if (licenseTypeIds) {
                    reportUrl += '&license_type_ids=' + licenseTypeIds
                }
                if (jurisdiction) {
                    reportUrl = reportUrl + '&jurisdiction_id=' + jurisdiction.value
                }
                this.navigateTo(reportUrl);
            } else {
                document.getElementById("flash-area").innerHTML = ('<div  class="warn">Please select a date range or leave both fields blank.</div>')
                dateFrom.classList.add('required-field')
                dateTo.classList.add('required-field')
            }

        }, 2500)


    }

    _clearLicenseTypeSelection() {
        const selectEl = this.licenseTypeSelectTarget
        Array.from(selectEl.options).forEach(option => {
            option.selected = false
        })

        if (selectEl.slim) {
            selectEl.slim.set([])
        }

        this.updateReport()
    }

    _setAllLicenseTypeOptions(selected) {
        const selectEl = this.licenseTypeSelectTarget
        Array.from(selectEl.options).forEach(option => {
            option.selected = selected
        })

        if (selectEl.slim) {
            selectEl.slim.set(Array.from(selectEl.selectedOptions).map(o => o.value))
        }

        this.updateReport()
    }
}
